export class RouteTo {

	// /**
	//  * Stripe Connect Setup
	//  *
	//  * @param userId
	//  */
	// public static paymentSetup(userId: string): string {
	// 	return 'https://connect.stripe.com/express/oauth/authorize?redirect_uri=https://app.isotopeticketing.com/paymentCallBack&client_id=ca_FEjtPwEfbDFEiwLSnMzq9sGftqkbUaqn&state=' + userId;
	// }

	/**
	 * Stripe Connect Standard Setup
	 *
	 * @param userId
	 */
	public static paymentSetup(userId: string, stripeId: string): string {
		return '/paymentCallback?userId=' + userId + '&stripeId=' + stripeId;
	}

	/**
	 * Return URL to Campaigns list
	 */
	public static campaigns(): string {
		return '/campaigns';
	}

	/**
	 * Return URL to create Campaign
	 */
	public static createCampaign(): string {
		return '/create-campaign';
	}

	/**
	 * Generates URL to campaign details
	 */
	public static campaignDashboard(campaignId: string): string {
		return '/campaign/' + campaignId;
	}

	/**
	 * Generates URL for payment confirmation
	 */
	public static paymentConfirmation(
		name: string,
		email: string,
		phoneNumber: string,
		code: string,
		campaignId: string,
		sellerId: string,
		orderComponents: string,
		floorplanLocationX: string,
		floorplanLocationY: string,
		address: string,
	): string {
		return (
			'/paymentConfirmation/' +
			name + '/' +
			email + '/' +
			phoneNumber + '/' +
			code + '/' +
			campaignId + '/' +
			sellerId + '/' +
			orderComponents + '/' +
			floorplanLocationX + '/' +
			floorplanLocationY + '/' +
			address
		);
	}

	/**
	 * Generates URL for payment confirmation
	 */
	public static bidConfirmation(
		name: string,
		email: string,
		phoneNumber: string,
		bidId: string,
		bid: string,
		campaignId: string,
		sellerId: string,
		floorplanLocationX: string,
		floorplanLocationY: string,
		address: string,
		createdBy: string,
		username: string,
		subdomain: string
	): string {
		return (
			'/bidConfirmation/' +
			name + '/' +
			email + '/' +
			phoneNumber + '/' +
			bidId + '/' +
			bid + '/' +
			campaignId + '/' +
			sellerId + '/' +
			floorplanLocationX + '/' +
			floorplanLocationY + '/' +
			address + '/' +
			createdBy + '/' +
			username + '/' +
			subdomain
		);
	}

	/**
	 * Generates URL to sell page
	 */
	public static receipt(orderId: string): string {
		return '/receipt/' + orderId;
	}

	/**
	 * Generates URL to sell page
	 */
	public static ownerSellPage(subdomain: string): string {
		return '/sell/' + subdomain;
	}

	/**
	 * Generates URL to sell page
	 */
	public static sellPage(subdomain: string, username: string): string {
		return '/sell/' + subdomain + '/' + username;
	}

	/**
	 * Generates URL to sell page
	 */
	public static setup(userId: string): string {
		return '/setup/' + userId;
	}

	/**
	 * Generates URL to showcase
	 */
	public static showcase(username: string): string {
		return '/showcase/' + username;
	}

	public static login(): string {
		return '/login';
	}
	
}



// WEBPACK FOOTER //
// ./src/lib/utils/routing.ts